export const MAX_UPLOAD_FILES_COUNT = 11
/** Max size before client-side compress (upload gate). */
export const MAX_AVATAR_SIZE_IN_BYTES = 5_000_000
